import React, { Component, PureComponent } from "react";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";
import { bindActionCreators } from "redux";
import QualTableComponent from "./Table_component";
import Loader from "@/common/components/Loader/Loader_component";
import styles from "./styles.scss"; // eslint-disable-line
import ThemeProvider from "toluna-react-components/ThemeProvider";
import {
  getTableForQuestion,
  addTable,
  removeTable,
  toggleFilter,
  loadFilterData,
  applyFilter as applyTableFilter,
  searchInFilter,
  loadMoreFilterData,
  loadData,
  changeTableSort
} from "./ducks";

import { connect } from "react-redux";

const THEME_CONFIG = {
  lightColor: "#327e95"
};

class QualTableContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.displayName = "QualTableContainer";

    this.loadData = this.loadData.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.searchInFilter = this.searchInFilter.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.loadMore = this.loadMore.bind(this);

    console.log("Props in constructor: ", props);
  }

  /*shouldComponentUpdate(nextProps, nextState) {
   return true;
   }*/

  componentWillReceiveProps(nextProps) {
    //console.log('CWRP: ', this.props, nextProps);
  }

  componentWillMount() {
    //console.log('CWM: ', this.props);

    const { questionId, addTable } = this.props;
    addTable({
      questionId
    });
  }

  componentDidMount() {
    //console.log('CDM: ', this.props);
  }

  componentWillUnmount() {
    console.error("componentWillUnmount");
    this.props.removeTable(this.props.questionId);
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log(prevProps.tableState, this.props.tableState);
    if (!prevProps.tableState && this.props.tableState && this.props.tableState.firstLoad && !this.props.tableState.isReload) {
      console.log('FIRST DATA LOAD');
      this.loadData(this.props.tableState.sortDir, false);
    }else if(prevProps.tableState && this.props.tableState && this.props.tableState.isReload){
      console.log('RELOADING DATA');
      console.log('isReload prev: ', prevProps.tableState.isReload, 'isReload now: ', this.props.tableState.isReload, 'loadingData: ', this.props.tableState.loadingData);
      //this.loadData(this.props.tableState.sortDir, false);
    }
  }

  loadData(sortDir, isSort) {
    const { tableState } = this.props;
    const { questionId } = tableState;

    console.log("loading data: ", sortDir, isSort);

    if (isSort === true) {
      this.props.changeTableSort({ questionId, sortDir });
      return;
    }

    this.props.loadData({ questionId, isSort, sortDir });
  }

  applyFilter(params) {
    console.log("Applying filter: ", params);

    const { filter, isSelectAll, selectAllChanged } = params;
    const { questionId } = this.props.tableState;

    this.props.applyTableFilter({ ...params, questionId });
  }

  toggleFilter(columnId) {
    const { questionId } = this.props;

    this.props.toggleFilter({ questionId, columnId });
    this.getFilter({ columnId });
  }

  getFilter({ columnId, searchQuery, lastRowIndex }) {
    const { questionId } = this.props;

    const params = {
      questionId: questionId,
      columnId: columnId
    };

    if (searchQuery && searchQuery.length > 0) {
      params.searchQuery = searchQuery;
    }

    this.props.loadFilterData(params);
  }

  searchInFilter(params) {
    console.log("Searching in filter: ", params);

    this.props.searchInFilter({ ...params, questionId: this.props.questionId });
  }

  loadMore({
    chunkSize,
    lastFilterItemIndex,
    columnId,
    isSelectAll,
    selectAllChanged,
    searchQuery
  }) {
    console.log("Load more filter in Table container: ", {
      chunkSize,
      lastFilterItemIndex,
      columnId,
      isSelectAll,
      selectAllChanged,
      searchQuery
    });

    const { questionId } = this.props;

    this.props.loadMoreFilterData({
      questionId,
      chunkSize,
      lastFilterItemIndex,
      columnId,
      isSelectAll,
      selectAllChanged,
      searchQuery
    });
  }

  render() {
    //console.log(this.props);

    const { loadingData, header, data, filters, hasMoreData, sortDir } = {
      ...(this.props.tableState || {})
    };
    const { questionId, translations } = { ...(this.props.tableState || {}) };

    console.log('Table state: ', this.props.tableState);
    //console.log(this.props.tableState, this.props.visibleFilter);

    return (
      <ThemeProvider config={THEME_CONFIG}>
        {this.props.tableState ? (
          <QualTableComponent
            loadingData={loadingData}
            withLoadingLayer={true}
            header={header}
            data={data}
            filters={[...filters]}
            questionId={questionId}
            hasMoreData={hasMoreData}
            getData={this.loadData}
            getFilter={this.getFilter}
            toggleFilter={this.toggleFilter}
            searchInFilter={this.searchInFilter}
            applyFilter={this.applyFilter}
            loadMore={this.loadMore}
            translations={translations}
            sortDir={sortDir}
          />
        ) : (
          <Loader />
        )}
      </ThemeProvider>
    );
  }
}

QualTableContainer.propTypes = {
  /*header: PropTypes.array.isRequired,
   data: PropTypes.array.isRequired,
   getDataFunction: PropTypes.func,
   onDataLoaded: PropTypes.func,
   chunkSize: PropTypes.number,
   questionId: PropTypes.string,
   translations: PropTypes.object*/
};

QualTableContainer.defaultProps = {
  /*chunkSize: 10*/
};

const mapStateToProps = (state, props) => {
  const { questionId } = props;
  const tableState = getTableForQuestion({ state, questionId });

  //console.log(questionId);

  return {
    tableState
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addTable: bindActionCreators(addTable, dispatch),
    removeTable: bindActionCreators(removeTable, dispatch),
    loadData: bindActionCreators(loadData, dispatch),
    toggleFilter: bindActionCreators(toggleFilter, dispatch),
    loadFilterData: bindActionCreators(loadFilterData, dispatch),
    applyTableFilter: bindActionCreators(applyTableFilter, dispatch),
    searchInFilter: bindActionCreators(searchInFilter, dispatch),
    loadMoreFilterData: bindActionCreators(loadMoreFilterData, dispatch),
    changeTableSort: bindActionCreators(changeTableSort, dispatch)
  };
};

export default CSSModules(
  connect(mapStateToProps, mapDispatchToProps)(QualTableContainer),
  styles
);



// WEBPACK FOOTER //
// ./components/qual/Table/Table_container.js